// Cart + branding persistence via localStorage, with a `cartUpdated` event
// so the navbar badge can react. House pattern across the cloud100 sites.

const CART_KEY = "fag_cart";
const BRANDING_KEY = "fag_branding";

export function getCart() {
  try {
    return JSON.parse(localStorage.getItem(CART_KEY) || "[]");
  } catch {
    return [];
  }
}

export function saveCart(cart) {
  localStorage.setItem(CART_KEY, JSON.stringify(cart));
  window.dispatchEvent(new Event("cartUpdated"));
}

export function addToCart(item) {
  const cart = getCart();
  const existing = cart.find((c) => c.product_id === item.product_id);
  if (existing) {
    existing.quantity += item.quantity;
  } else {
    cart.push(item);
  }
  saveCart(cart);
}

export function updateQuantity(productId, quantity) {
  const cart = getCart()
    .map((c) => (c.product_id === productId ? { ...c, quantity } : c))
    .filter((c) => c.quantity > 0);
  saveCart(cart);
}

export function removeFromCart(productId) {
  saveCart(getCart().filter((c) => c.product_id !== productId));
}

export function clearCart() {
  saveCart([]);
}

export function cartCount() {
  return getCart().reduce((n, i) => n + i.quantity, 0);
}

export function cartTotal() {
  return getCart().reduce((s, i) => s + i.price * i.quantity, 0);
}

// --- Branding (logo) — kept once per order, set on the product page. ---
export function getBranding() {
  try {
    return JSON.parse(localStorage.getItem(BRANDING_KEY) || "null");
  } catch {
    return null;
  }
}

export function saveBranding(branding) {
  localStorage.setItem(BRANDING_KEY, JSON.stringify(branding));
}

export function clearBranding() {
  localStorage.removeItem(BRANDING_KEY);
}
